@if ({
  draftSkills: draftSkills$ | async,
  savedSkills: savedSkills$ | async,
  suggestions: suggestions$ | async,
  hasExactMatch: hasExactMatch$ | async,
  moderationLastChangeDate: moderationLastChangeDate$ | async
}; as data) {
  <app-jobseeker-skills-edit-form
    [title]="title"
    [placeholder]="placeholder"
    [draftSkills]="data.draftSkills"
    [suggestions]="data.suggestions"
    [hasExactMatch]="!!data.hasExactMatch"
    [saveDisabled]="!data.draftSkills?.length && !data.savedSkills?.length"
    (onQueryChange)="onQueryChange($event)"
    (onSelectSkill)="onSelectSkill($event)"
    (onAddCustomSkill)="onAddCustomSkill($event)"
    (onRemoveSkill)="onRemoveSkill($event)"
    (onReorderSkills)="onReorderSkills($event)"
    (onSave)="onSave(data.moderationLastChangeDate, data.draftSkills)"
  ></app-jobseeker-skills-edit-form>
}
